<template>
  <home-slider></home-slider>
</template>

<script>
import HomeSlider from "@/esf_antarctica_lederhosenland/core/components/home/HomeSlider.vue";

export default{
  components:{
      HomeSlider
  }
}
</script>

<style lang="scss" scoped>
</style>